import {
  useCallback, useState,
} from 'react';
import { getLatLngFromAddress as getLatLngFromAddressWithCache } from '~/_shared/utils/geolocation/cachedGeolocation';
import {
  getAddressFromLatLng, getUserPosition as getUserPositionFromNavigator,
} from '~/_shared/utils/geolocation/geolocation.helpers';
import type { GeoLocation } from './geolocation';

export const useGetLocation = () => {
  const [isFetchingGeoLocation, setIsFetchingGeoLocation] = useState(false);
  const [isGeoError, setIsGeoError] = useState(false);

  const getUserPosition = useCallback(async (): Promise<GeoLocation> => {
    setIsFetchingGeoLocation(true);
    try {
      const position = await getUserPositionFromNavigator();
      const response = await getAddressFromLatLng(position.coords.latitude, position.coords.longitude);
      setIsFetchingGeoLocation(false);
      setIsGeoError(false);
      return response;
    }
    catch (error) {
      setIsFetchingGeoLocation(false);
      setIsGeoError(true);
      throw error;
    }
  }, []);

  const getLatLngFromAddress = useCallback(async ({
    address,
  }: {
    address: string;
  }): Promise<GeoLocation> => {
    try {
      setIsFetchingGeoLocation(true);
      const response = await getLatLngFromAddressWithCache(address);
      setIsFetchingGeoLocation(false);
      const firstLocation = response[0];
      if (!firstLocation) {
        setIsGeoError(true);
        throw new Error('Could not get lat lng location');
      }
      return firstLocation;
    }
    catch (error) {
      setIsFetchingGeoLocation(false);
      setIsGeoError(true);
      throw error;
    }
  }, []);

  const resetGeoError = useCallback(() => {
    setIsGeoError(false);
  }, []);

  return {
    getUserPosition,
    isFetchingGeoLocation,
    isGeoError,
    resetGeoError,
    getLatLngFromAddress,
  };
};
